import { useClientMatterSearch } from '../../../hooks/useClientMatterSearch';
import { Layout, MainContent } from './BodyLayout.styles';
import { InvoiceForm } from '../../../pages/invoiceForm/InvoiceForm';
import { useCallback, useEffect, useState } from 'react';
import { getBills } from '../../../apis/getBills';
import { ApiResponse } from '../../../types//index';
import { UseAuth } from '../../../contexts/AuthContext';

export interface InvoiceData {
  BILL_NUM: number;
  BILL_DATE: string;
  CLIENT_CODE: string;
  CLIENT_NAME: string;
  MATT_CAT_CODE: string;
  CLNT_MATT_CODE: string;
  MATTER_NAME: string;
}

export const BodyLayout = () => {
  const { getAccessToken } = UseAuth();
  const {
    clientData,
    matterData,
    selectedClientUno,
    selectedMatterUno,
    handleClientSearch,
    handleClientSelect,
    handleMatterSelect,
    isLoadingMatters,
  } = useClientMatterSearch();
  const [invoiceData, setInvoiceData] = useState<InvoiceData[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoadingInvoices, setIsLoadingInvoices] = useState(false);

  const handleInvoiceRequest = useCallback(async (): Promise<ApiResponse<InvoiceData[]> | null> => {
    if (selectedMatterUno?.matterCode && selectedClientUno?.clientCode) {
      try {
        const response = await getBills({
          selectedClientUno: selectedClientUno.clientCode,
          selectedMatterUno: selectedMatterUno.matterCode,
          getAccessToken
        });
        return response;
      } catch (error) {
        console.error('Error in handleInvoiceRequest:', error);
        return {
          success: false,
          error: error instanceof Error ? error.message : 'An unknown error occurred',
        };
      }
    }
    return null;
  }, [selectedClientUno, selectedMatterUno]);

  useEffect(() => {
    let isMounted = true;

    const fetchInvoiceData = async () => {
      if (!selectedMatterUno) return;

      setIsLoadingInvoices(true);
      setError(null);

      try {
        const response = await handleInvoiceRequest();

        if (!isMounted) return;

        if (response?.success && response.data) {
          setInvoiceData(response.data);
        } else if (response?.error) {
          setError(response.error);
          setInvoiceData(null);
        } else {
          setError('No data received');
          setInvoiceData(null);
        }
      } catch (error) {
        if (!isMounted) return;

        console.error('Error fetching invoice data:', error);
        setError(
          error instanceof Error ? error.message : 'An unknown error occurred'
        );
        setInvoiceData(null);
      } finally {
        if (isMounted) {
          setIsLoadingInvoices(false);
        }
      }
    };

    fetchInvoiceData();
    return () => {
      isMounted = false;
    };
  }, [handleInvoiceRequest, selectedMatterUno]);
  console.log(clientData)
  return (
    <Layout>
      <MainContent>
        <InvoiceForm
          isLoadingMatters={isLoadingMatters}
          isLoadingInvoices={isLoadingInvoices}
          clientData={clientData}
          matterData={matterData}
          invoiceData={invoiceData}
          error={error}
          onClientSelect={handleClientSelect}
          onClientSearch={handleClientSearch}
          onMatterSelect={handleMatterSelect}
        />
      </MainContent>
    </Layout>
  );
}
